import type { CodexMatchupForecast } from "@dailywars/core/engine";

import { Card } from "#/components/ui/card";

import {
  CodexCalculatorColumn,
  CodexCalculatorUnitSection,
  type CodexCalculatorColumnProps,
} from "./-codex.damageCalculator.columns";
import { CodexCalculatorMatchupCenter } from "./-codex.damageCalculator.results";

function CodexDamageCalculatorMatchup({
  forecast,
  attackerDisplayHp,
}: {
  forecast: CodexMatchupForecast;
  attackerDisplayHp: number;
}) {
  return (
    <CodexCalculatorMatchupCenter
      forecast={forecast}
      attackerDisplayHp={attackerDisplayHp}
      className="w-full min-w-0 self-stretch sm:w-auto sm:min-w-36 sm:self-center"
    />
  );
}

export function CodexDamageCalculatorCard({
  forecast,
  attackerProps,
  defenderProps,
  attackerDisplayHp,
}: {
  forecast: CodexMatchupForecast;
  attackerProps: CodexCalculatorColumnProps;
  defenderProps: CodexCalculatorColumnProps;
  attackerDisplayHp: number;
}) {
  const matchup = (
    <CodexDamageCalculatorMatchup forecast={forecast} attackerDisplayHp={attackerDisplayHp} />
  );

  return (
    <Card className="w-full max-w-full p-4 sm:w-fit sm:p-5">
      <div className="flex flex-col gap-5 sm:hidden">
        <CodexCalculatorUnitSection label="Attacker" {...attackerProps} />
        <div className="border-y border-border py-4">{matchup}</div>
        <CodexCalculatorUnitSection label="Defender" {...defenderProps} />
      </div>
      <div className="hidden items-start justify-center gap-8 sm:flex">
        <CodexCalculatorColumn {...attackerProps} />
        {matchup}
        <CodexCalculatorColumn {...defenderProps} />
      </div>
    </Card>
  );
}
